import React from "react";
import { SearchBar } from "../searchBar";

const SearchInput = ({ ...rest }) => {
    return <SearchBar {...rest} />;
};

export default SearchInput;
